export default "__VITE_ASSET__36b1c83a__"